<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
body{
  margin: 0px;
}
input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"]{
        -moz-appearance: textfield;
    }
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar {
    width: 8px;
    /*滚动条宽度*/
    height: 8px;
    /*滚动条高度*/
    background-color: #e6eaee;
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(202, 202, 202, 0.3);
    background-color: #bdc6ce;
    /*滚动条的背景颜色*/
  }
.el-input__inner{
  background-color: #fff;
}
.el-input__inner:focus {
  border-color: #006E4B;
}
.el-select .el-input.is-focus .el-input__inner {
    border-color: #006E4B;
}
.el-select .el-input__inner:focus {
    border-color: #006E4B;
}
.el-date-table td.current:not(.disabled) span {
    color: #FFF;
    background-color: #006E4B;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #006E4B;
}
.el-button--goon:focus,
.el-button--goon:hover {
  background: #006E4B;
  border-color:  #05573d;
  color: #fff;
}
.el-button--addbtn:focus,
.el-button--addbtn:hover {
  background: #fff;
  border-color:  #05573d;
  color:  #006E4B;
}
.el-button--goon {
  color: #FFF;
  background-color: #006E4B;
  border-color:  #006E4B;
  font-size: 15px;
  width: 85px;
}
.el-button--addbtn {
  color:  #006E4B;
  background-color: #fff;
  border-color:  #006E4B;
  font-size: 15px;
  width: 85px;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color:  #006E4B;
  border-color:  #006E4B;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color:  #006E4B;
}
.el-checkbox__inner:hover{
  border-color:  #006E4B;
}
.el-checkbox__input.is-checked+.el-checkbox__label {
    color:#006E4B;
}
/* .el-form-item__label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
} */
.el-textarea__inner:focus,
.el-textarea__inner:hover{
  border-color: #006E4B;
}
.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{
  border-color:  #006E4B;
}
.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{
  color:  #006E4B;
}
.el-radio__input.is-checked .el-radio__inner{
  border-color: #006E4B;
  background:#006E4B;
}
.el-radio__input.is-checked+.el-radio__label {
  color:#006E4B;
}
.el-select-dropdown__item.selected{
  color:#006E4B;
}
.el-tabs__item.is-active {
  color:#006E4B;
}
.el-tabs__item.is-active:hover {
  color:#006E4B;
}
</style>



// WEBPACK FOOTER //
// App.vue?41811595